import React from 'react';
import '../../Styles/UserAccountGridCenter.css';
import handleRemoveFile from '../UAMediaRemover';
import kleidoLogo from "../../../../../assets/images/Kleido.png"
import GridLayout from '../../../../common/Grid/gridMode';
import { FetchUserData } from "./UserFetchMockData";


const PREVIEW_HEIGHT = 420;
const TILE_MIN_WIDTH = 160;
const TILE_HEIGHT = 160;

function randomBetween(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function generateQualityData(fileName) {
  const tqs = randomBetween(60, 95);
  const prs = randomBetween(60, 95);
  const scs = randomBetween(60, 95);
  const iss = randomBetween(60, 95);
  const agp = randomBetween(5, 30);
  const cii = Math.round(0.25 * tqs + 0.25 * prs + 0.2 * scs + 0.2 * iss - 0.1 * agp);

  let classification = 'Unclassified';
  if (cii >= 85) classification = 'Premium Verified';
  else if (cii >= 75) classification = 'High Integrity';
  else if (cii >= 65) classification = 'Standard Grade';
  else classification = 'Requires Review';

  return { fileName, tqs, prs, scs, iss, agp, cii, classification };
}

function generateMonetisationData(fileName) {
  const seed = fileName.length % 4;
  const tiers = ['Bronze', 'Silver', 'Gold', 'Platinum'];
  const tier = tiers[seed];
  const earningsMap = { Bronze: randomBetween(40, 120), Silver: randomBetween(120, 400), Gold: randomBetween(400, 1200), Platinum: randomBetween(1200, 4000) };
  const cpmMap = { Bronze: '1.20 - 2.80', Silver: '2.80 - 6.50', Gold: '6.50 - 14.00', Platinum: '14.00 - 32.00' };
  const licensedUses = randomBetween(12, 380);
  const bars = [randomBetween(30, 90), randomBetween(40, 95), randomBetween(35, 92), randomBetween(50, 99)];
  const channels = ['AI Lab Training', 'Creative Studios', 'Marketplace', 'Brand Partnerships'];

  return { fileName, tier, earnings: earningsMap[tier], cpm: cpmMap[tier], licensedUses, bars, channels };
}

const backdropStyle = {
  position: 'fixed',
  inset: 0,
  background: "black",
  backdropFilter: 'blur(6px)',
  zIndex: 9999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

// Sentinel for "post to my own feed" — always the first option in the list.
const NONE_PROFILE = 'none';

const profileSelectStyle = {
  marginTop: '4px',
  width: '100%',
  minWidth: '150px',
  maxWidth: '220px',
  background: 'rgba(36,36,45,0.6)',
  color: '#fff',
  border: '1px solid rgba(204,203,207,0.28)',
  borderRadius: '8px',
  padding: '6px 10px',
  fontSize: '13px',
  outline: 'none',
  cursor: 'pointer',
};

// Dark <option> background for browsers that don't inherit it (Chrome/Windows).
const profileOptionStyle = { background: 'rgba(36, 36, 45, 0.2)', color: '#fff' };

const profileAvatarStyle = {
  width: '22px',
  height: '22px',
  borderRadius: '50%',
  objectFit: 'cover',
  border: '1px solid rgba(255,255,255,0.25)',
  flexShrink: 0,
};

const cardStyle = {
  background: "black",
  border: '1px solid rgba(204, 203, 207, 0.28)',
  borderRadius: '18px',
  padding: '32px 36px 28px 36px',
  minWidth: '340px',
  maxWidth: '480px',
  width: '90vw',
  color: '#f0eeff',
  position: 'relative',
  fontFamily: 'inherit',
};

const closeBtnStyle = {
  position: 'absolute',
  top: '14px',
  right: '18px',
  background: 'none',
  border: 'none',
  color: '#a090cc',
  fontSize: '22px',
  cursor: 'pointer',
  lineHeight: 1,
  padding: '2px 6px',
  borderRadius: '6px',
  transition: 'color 0.18s',
};

const accentBarStyle = {
  height: '3px',
  borderRadius: '2px',
  background: 'white',
  marginBottom: '18px',
  width: '100%',
};

const metricRowStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '10px',
  fontSize: '13.5px',
};

const metricLabelStyle = {
  color: 'white',
  fontWeight: 500,
  letterSpacing: '0.03em',
};

const metricValueStyle = {
  fontWeight: 700,
  fontSize: '14px',
  color: 'white',
  borderRadius: '6px',
  padding: '2px 10px',
  minWidth: '40px',
  textAlign: 'center',
};

const classificationBadgeStyle = (cls) => {
  return {
    display: 'inline-block',
    background: 'rgba(36,36,45,0.2)',
    color: '#fff',
    fontWeight: 700,
    fontSize: '12px',
    letterSpacing: '0.06em',
    borderRadius: '20px',
    padding: '4px 14px',
    marginTop: '4px',
    border: "1px solid gray"
  };
};

const ciiCircleStyle = (score) => ({
  width: '64px',
  height: '64px',
  borderRadius: '50%',
  background: 'rgba(36,36,45,0.2)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto 14px auto',
  border: "1px solid gray"
});

const tierBadgeStyle = (tier) => {
  const palettes = {
    Bronze: 'linear-gradient(90deg,#b45309,#d97706)',
    Silver: 'linear-gradient(90deg,#64748b,#94a3b8)',
    Gold: 'linear-gradient(90deg,#b45309,#fbbf24)',
    Platinum: 'linear-gradient(90deg,#7c3aed,#06b6d4)',
  };
  return {
    display: 'inline-block',
    background: palettes[tier] || palettes.Bronze,
    color: '#fff',
    fontWeight: 800,
    fontSize: '13px',
    letterSpacing: '0.1em',
    borderRadius: '20px',
    padding: '4px 18px',
    marginTop: '2px',
    textTransform: 'uppercase',
  };
};

const chipStyle = {
  display: 'inline-block',
  background: 'none',
  border: '1px solid white',
  color: 'white',
  borderRadius: '20px',
  padding: '3px 12px',
  fontSize: '12px',
  fontWeight: 600,
  marginRight: '6px',
  marginBottom: '6px',
};

const actionBtnBase = {
  padding: '7px 15px',
  borderRadius: '8px',
  fontWeight: 600,
  fontSize: '13px',
  cursor: 'pointer',
  border: '1.5px solid transparent',
  transition: 'opacity 0.18s, box-shadow 0.18s',
  outline: 'none',
  letterSpacing: '0.02em',
  whiteSpace: 'nowrap',
};

const enabledCheckQualityStyle = {
  ...actionBtnBase,
  background: 'linear-gradient(90deg, gray 0%, white)',
  color: 'black',
  borderColor: 'transparent',
  boxShadow: '0 2px 10px darkslategray;',
};

const disabledCheckQualityStyle = {
  ...actionBtnBase,
  background: 'white',
  color: 'black',
  borderColor: 'darkslategray',
  cursor: 'not-allowed',
  boxShadow: 'none',
};

const enabledMonetisationStyle = {
  ...actionBtnBase,
  background: 'linear-gradient(90deg, white 0%,gray)',
  color: 'black',
  borderColor: 'transparent',
  boxShadow: '0 2px 10px darkslategray',
};

const disabledMonetisationStyle = {
  ...actionBtnBase,
  background: 'rgba(40,80,120,0.18)',
  color: 'rgba(140,200,220,0.38)',
  borderColor: 'rgba(6,182,212,0.12)',
  cursor: 'not-allowed',
  boxShadow: 'none',
};

function QualityModal({ data, onClose }) {
  return (
    <div style={backdropStyle} onClick={onClose} >
      <div style={cardStyle} onClick={(e) => e.stopPropagation()}>
      <img src={kleidoLogo} alt="Kleido" className="h-12 w-12 rounded-lg" />
        <button style={closeBtnStyle} onClick={onClose} aria-label="Close">x</button>
        <div style={{ textAlign: 'center', marginBottom: '16px' }}>
          <div style={{ fontSize: '11px', color: 'white', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: '6px' }}>
            Kleido AI
          </div>
          <div style={{ fontWeight: 700, fontSize: '16px', color: 'white', marginBottom: '2px' }}>
            Media Quality Report
          </div>
          <div style={{ fontSize: '11px', color: 'white', maxWidth: '320px', margin: '0 auto', wordBreak: 'break-all' }}>
            {data.fileName}
          </div>
        </div>

        <div style={ciiCircleStyle(data.cii)}>
          <span style={{ fontSize: '22px', fontWeight: 800, color: '#fff', lineHeight: 1.1 }}>{data.cii}</span>
          <span style={{ fontSize: '10px', color: 'rgba(255,255,255,0.7)', letterSpacing: '0.08em' }}>CII</span>
        </div>

        <div style={{ textAlign: 'center', marginBottom: '18px' }}>
          <span style={classificationBadgeStyle(data.classification)}>{data.classification}</span>
        </div>

        <div style={{ background: 'rgba(255,255,255,0.03)', borderRadius: '10px', padding: '14px 16px', marginBottom: '8px', color: 'white' }}>
          {[
            { label: 'TQS — Technical Quality', value: data.tqs },
            { label: 'PRS — Realism / Authenticity', value: data.prs },
            { label: 'SCS — Semantic Coherence', value: data.scs },
            { label: 'ISS — Identity Stability', value: data.iss },
            { label: 'AGP — AI Generation %', value: data.agp + '%' },
          ].map(({ label, value }) => (
            <div key={label} style={metricRowStyle}>
              <span style={metricLabelStyle}>{label}</span>
              <span style={{ ...metricValueStyle, color: 'white' }}>{value}</span>
            </div>
          ))}
        </div>

        <div style={{ fontSize: '11px', color: 'white', textAlign: 'center', marginTop: '10px' }}>
          Powered by Kleido AI. 
        </div>
      </div>
    </div>
  );
}

function MonetisationModal({ data, onClose }) {
  const maxBar = Math.max(...data.bars);
  return (
    <div style={backdropStyle} onClick={onClose}>
      <div style={cardStyle} onClick={(e) => e.stopPropagation()}>
        <img src={kleidoLogo} alt="Kleido" className="h-12 w-12 rounded-lg" />
        <button style={closeBtnStyle} onClick={onClose} aria-label="Close">x</button>
        <div style={{ textAlign: 'center', marginBottom: '16px' }}>
          <div style={{ fontSize: '11px', color: 'white', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: '6px' }}>
            Monetisation Intelligence
          </div>
          <div style={{ fontWeight: 700, fontSize: '16px', color: 'white', marginBottom: '2px' }}>
            Earnings Potential Report
          </div>
          <div style={{ fontSize: '11px', color: 'white', maxWidth: '320px', margin: '0 auto', wordBreak: 'break-all' }}>
            {data.fileName}
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', marginBottom: '16px' }}>
          <div style={{ flex: 1, borderRadius: '10px', padding: '12px', textAlign: 'center' }}>
            <div style={{ fontSize: '11px', color: 'white', letterSpacing: '0.08em', marginBottom: '4px' }}>Est. / Month</div>
            <div style={{ fontWeight: 800, fontSize: '20px', color: 'white' }}>${data.earnings.toLocaleString()}</div>
          </div>
          <div style={{ flex: 1, borderRadius: '10px', padding: '12px', textAlign: 'center' }}>
            <div style={{ fontSize: '11px', color: 'white', letterSpacing: '0.08em', marginBottom: '4px' }}>Licensing Tier</div>
            <span style={tierBadgeStyle(data.tier)}>{data.tier}</span>
          </div>
        </div>

        <div style={{ borderRadius: '10px', padding: '14px 16px', marginBottom: '12px', color: "white" }}>
          <div style={metricRowStyle}>
            <span style={metricLabelStyle}>Licensed Uses</span>
            <span style={metricValueStyle}>{data.licensedUses}</span>
          </div>
          <div style={metricRowStyle}>
            <span style={metricLabelStyle}>Recommended CPM</span>
            <span style={{ ...metricValueStyle, fontSize: '12px' }}>${data.cpm}</span>
          </div>
        </div>

        <div style={{ marginBottom: '12px' }}>
          <div style={{ fontSize: '11px', color: 'white', letterSpacing: '0.08em', marginBottom: '8px' }}>Top Channels</div>
          <div>{data.channels.map((ch) => <span key={ch} style={chipStyle}>{ch}</span>)}</div>
        </div>

        <div style={{ marginBottom: '8px' }}>
          <div style={{ fontSize: '11px', color: 'white', letterSpacing: '0.08em', marginBottom: '8px' }}>Adoption Trend</div>
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: '8px', height: '48px' }}>
            {data.bars.map((val, i) => (
              <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end', height: '100%' }}>
                <div
                  style={{
                    width: '100%',
                    height: `${Math.round((val / maxBar) * 100)}%`,
                    borderRadius: '4px 4px 2px 2px',
                    background: i === data.bars.length - 1
                      ? 'linear-gradient(gray,black,white 100%)'
                      : 'white',
                    transition: 'height 0.3s',
                  }}
                />
                <div style={{ fontSize: '9px', color: 'white', marginTop: '3px' }}>W{i + 1}</div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ fontSize: '11px', color: 'white', textAlign: 'center', marginTop: '8px' }}>
          Powered by Kleido Monetisation Engine
        </div>
      </div>
    </div>
  );
}

/* ---------------- MEDIA GRID STYLES ---------------- */

// Fixed-size shell. Nothing inside can push it wider or taller.
// One file  -> fills the box exactly, no scrollbar.
// Many files -> grid of tiles, scrolls internally once they overflow.
const mediaPreviewStyle = (isSingle) => ({
  width: '100%',
  height: `${PREVIEW_HEIGHT}px`,
  maxHeight: `${PREVIEW_HEIGHT}px`,
  boxSizing: 'border-box',
  overflowY: isSingle ? 'hidden' : 'auto',
  overflowX: 'hidden',
  background: 'rgba(36,36,45,0.2)',
  border: '1px solid rgba(204,203,207,0.18)',
  borderRadius: '10px',
  padding: '10px',
});

const mediaGridStyle = (isSingle) =>
  isSingle
    ? {
        // Single item: one cell that fills the whole content box.
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridTemplateRows: '1fr',
        height: '100%',
        gap: 0,
      }
    : {
        // Multiple items: uniform tiles that reflow by container width.
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fill, minmax(${TILE_MIN_WIDTH}px, 1fr))`,
        gridAutoRows: `${TILE_HEIGHT}px`,
        gap: '10px',
      };

const tileStyle = (isSelected, isSingle) => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  borderRadius: '8px',
  background: '#000',
  cursor: isSingle ? 'default' : 'pointer',
  border: !isSingle && isSelected ? '2px solid #fff' : '1px solid rgba(255,255,255,0.12)',
  boxSizing: 'border-box',
});

// Media always fills its cell and is cropped — never overflows.
const tileMediaStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
};

const removeXStyle = (isSingle) => ({
  position: 'absolute',
  top: isSingle ? '10px' : '6px',
  right: isSingle ? '10px' : '6px',
  width: isSingle ? '30px' : '24px',
  height: isSingle ? '30px' : '24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  background: 'rgba(0,0,0,0.65)',
  border: '1px solid rgba(255,255,255,0.35)',
  color: '#fff',
  fontSize: isSingle ? '17px' : '14px',
  lineHeight: 1,
  fontWeight: 700,
  cursor: 'pointer',
  padding: 0,
  zIndex: 3,
});

const tileBadgeStyle = {
  position: 'absolute',
  bottom: '6px',
  left: '6px',
  fontSize: '9px',
  fontWeight: 700,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: '#fff',
  background: 'rgba(0,0,0,0.6)',
  borderRadius: '4px',
  padding: '2px 6px',
  zIndex: 2,
  maxWidth: 'calc(100% - 12px)',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export default function UserAccountCreatePost({ userid, profileid }) {
  const [description, setDescription] = React.useState('');
  const [uploadedMedia, setUploadedMedia] = React.useState([]);
  const [selectedId, setSelectedId] = React.useState(null);
  const [isPublic, setIsPublic] = React.useState(false);
  const [qualityModal, setQualityModal] = React.useState(null);
  const [monetisationModal, setMonetisationModal] = React.useState(null);

  // Stable keys so removing a tile never remounts the wrong <video>/<img>.
  const nextId = React.useRef(0);

  const [profiles, setProfiles] = React.useState([]);
  const [profilesLoading, setProfilesLoading] = React.useState(true);
  // Defaults to the incoming prop if given, otherwise "post to my own feed".
  const [selectedProfileId, setSelectedProfileId] = React.useState(profileid || NONE_PROFILE);

  // Pull the profiles array out of the user record (UserStructureWithProfiles).
  React.useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setProfilesLoading(true);
      try {
        // Tolerates FetchUserData being sync or returning a promise.
        const data = await Promise.resolve(FetchUserData(userid));

        // Tolerates a single user object or an array of users.
        const user = Array.isArray(data)
          ? data.find((u) => u && u.userId === userid) || data[0]
          : data;

        // Skip the blank template row that ships in the structure.
        const list = (user && Array.isArray(user.profiles) ? user.profiles : []).filter(
          (p) => p && (p.profileId || p.profileUUID || p.profileName)
        );

        if (!cancelled) setProfiles(list);
      } catch (err) {
        console.error('Failed to load profiles:', err);
        if (!cancelled) setProfiles([]);
      } finally {
        if (!cancelled) setProfilesLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [userid]);

  const profileKey = (p) => p.profileId || p.profileUUID || p.profileName;

  const selectedProfile =
    selectedProfileId === NONE_PROFILE
      ? null
      : profiles.find((p) => profileKey(p) === selectedProfileId) || null;

  // Where the post lands: a named profile, or the user's own feed.
  const postTarget = selectedProfile
    ? {
        type: 'profile',
        userId: userid,
        profileId: selectedProfile.profileId,
        profileUUID: selectedProfile.profileUUID,
        profileName: selectedProfile.profileName,
      }
    : { type: 'userFeed', userId: userid };

  // Keep a live ref of the media so unmount cleanup can revoke every blob URL.
  const mediaRef = React.useRef(uploadedMedia);
  mediaRef.current = uploadedMedia;
  React.useEffect(() => {
    return () => mediaRef.current.forEach((m) => m.url && URL.revokeObjectURL(m.url));
  }, []);

  const hasMedia = uploadedMedia.length > 0;
  const isSingle = uploadedMedia.length === 1;
  const selectedMedia =
    uploadedMedia.find((m) => m.id === selectedId) || uploadedMedia[0] || null;

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    const newMedia = files.map((file) => ({
      id: nextId.current++,
      file,
      url: URL.createObjectURL(file),
      name: file.name,
      type: file.type,
    }));
    setUploadedMedia((prev) => [...prev, ...newMedia]);
    // Reset so re-picking the same file still fires onChange.
    e.target.value = '';
  };

  const handleRemove = (id) => {
    setUploadedMedia((prev) => {
      const target = prev.find((m) => m.id === id);
      if (target && target.url) URL.revokeObjectURL(target.url);
      return prev.filter((m) => m.id !== id);
    });
    setSelectedId((cur) => (cur === id ? null : cur));
  };

  const clearAllMedia = () => {
    uploadedMedia.forEach((m) => m.url && URL.revokeObjectURL(m.url));
    setUploadedMedia([]);
    setSelectedId(null);
  };

  const handlePost = () => {
    if (!description.trim() && uploadedMedia.length === 0) {
      alert('Please add a description or media before posting.');
      return;
    }
    if (!userid) {
      alert('User ID is required to post.');
      return;
    }

    const payload = {
      ...postTarget,
      description: description.trim(),
      visibility: isPublic ? 'public' : 'private',
      media: uploadedMedia.map((m) => ({ name: m.name, type: m.type })),
    };
    console.log('Post payload:', payload);

    alert(
      postTarget.type === 'profile'
        ? `Post submitted to profile "${postTarget.profileName || postTarget.profileId}"!`
        : 'Post submitted to your feed!'
    );

    setDescription('');
    clearAllMedia();
  };

  const handleOpenQuality = () => {
    if (!selectedMedia) return;
    setQualityModal(generateQualityData(selectedMedia.name));
  };

  const handleOpenMonetisation = () => {
    if (!selectedMedia) return;
    setMonetisationModal(generateMonetisationData(selectedMedia.name));
  };

  return (
    <div className="uacf-post-container" style={{ maxHeight: 1000, minHeight: 300, height: "auto", width: "100%" }}>
      <div className="uac-post-container" style={{ maxHeight: "100%", height: "auto" }}>
        <textarea
          className="uacp-description-input"
          placeholder="What's on your mind?"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={3}
          style={{ height: 200 }}
        />

        <div style={{ display: 'flex', alignItems: 'left', gap: '1px', flexDirection: "row" }}>
          <div style={{width: "50%" }}>
          <div style={{ width: "50%", display: "flex", flexDirection: "row" }}>
            <label className="uacp-upload-btn" style={{border: "1px solid gray", fontWeight: "bold" }}>
              <p style={{marginTop: -5}}>
              Upload
              </p>
              <input
                type="file"
                accept="image/*,video/*"
                multiple
                style={{ display: 'none', alignContent: "center" }}
                onChange={handleFileUpload}
              />
            </label>

            <button className="uacp-post-btn" onClick={handlePost} style={{border: "1px solid gray", fontWeight: "bold" }}>
            <p style={{marginTop: -5}}>
              Post
              </p>
            </button>

            <div className="uac-visibility-section" style={{ width: "300px", height: "55%", marginTop: 7, marginLeft: 30 }}>
              <label className="up-toggle-switch">
                <input
                  type="checkbox"
                  checked={isPublic}
                  onChange={() => setIsPublic((prev) => !prev)}
                  style={{ display: 'none' }}
                />
                <span className="up-toggle-slider" />
              </label>
              <span className="uac-visibility-status" style={{marginTop: 5}}>{isPublic ? 'Public' : 'Private'}</span>
            </div>
          </div>
          </div>

          <div style={{width: "100%", display: "flex", flexDirection: "row", gap: 20, justifyContent: "flex-end"}}>
          <div className="uac-id-field" style={{marginTop: 5}}>
            <span className="uac-metadata-label">User ID</span>
            {userid ? (
              <span className="uac-id-value">{userid}</span>
            ) : (
              <span className="uac-id-missing">Not provided</span>
            )}
          </div>

          <div className="uac-id-field" style={{marginTop: 5}}>
            <span className="uac-metadata-label">Post to</span>

            <div style={{ display: 'flex', alignItems: 'center', gap: '8px'}}>
              {selectedProfile && selectedProfile.profileImage ? (
                <img
                  src={selectedProfile.profileImage}
                  alt={selectedProfile.profileName || 'Profile'}
                  style={profileAvatarStyle}
                />
              ) : null}

              <select
                className="uac-profile-select"
                value={selectedProfileId}
                onChange={(e) => setSelectedProfileId(e.target.value)}
                disabled={profilesLoading}
                style={profileSelectStyle}
                aria-label="Choose the profile to post from"
              >
                <option value={NONE_PROFILE} style={profileOptionStyle}>
                  None
                </option>

                {profiles.map((p) => (
                  <option key={profileKey(p)} value={profileKey(p)} style={profileOptionStyle}>
                    {p.profileName || p.profileId || p.profileUUID}
                  </option>
                ))}
              </select>
            </div>
          </div>
          </div>
        </div>

        {hasMedia && (
          <div style={{ width: '100%', marginTop: 30 }}>
            {/* Header: count + clear all */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '8px',
                fontSize: '12px',
                color: 'rgba(255,255,255,0.75)',
              }}
            >
              <span>
                {uploadedMedia.length} file{uploadedMedia.length > 1 ? 's' : ''} attached
                {!isSingle && selectedMedia ? ` — analysing "${selectedMedia.name}"` : ''}
              </span>
              <button
                onClick={clearAllMedia}
                style={{
                  background: 'none',
                  border: '1px solid rgba(255,255,255,0.25)',
                  color: 'rgba(255,255,255,0.75)',
                  borderRadius: '6px',
                  padding: '3px 10px',
                  fontSize: '11px',
                  cursor: 'pointer',
                }}
              >
                Clear all
              </button>
            </div>

            {/* FIXED-SIZE PREVIEW BOX
                1 file  -> fills the box edge to edge
                2+ files -> grid of tiles, scrolls inside the same box */}
            <div className="uac-media-preview" style={mediaPreviewStyle(isSingle)}>
              <div style={mediaGridStyle(isSingle)}>
                {uploadedMedia.map((media) => {
                  const isVideo = media.type && media.type.startsWith('video/');
                  const isSelected = selectedMedia && selectedMedia.id === media.id;
                  return (
                    <div
                      key={media.id}
                      style={tileStyle(isSelected, isSingle)}
                      title={media.name}
                      onClick={isSingle ? undefined : () => setSelectedId(media.id)}
                    >
                      {isVideo ? (
                        <video
                          src={media.url}
                          style={tileMediaStyle}
                          // Full-size single video is worth real controls;
                          // a 160px tile is not.
                          controls={isSingle}
                          muted={!isSingle}
                          playsInline
                          preload="metadata"
                        />
                      ) : (
                        <img src={media.url} alt={media.name} style={tileMediaStyle} />
                      )}

                      <button
                        className="uac-remove-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemove(media.id);
                        }}
                        style={removeXStyle(isSingle)}
                        aria-label={`Remove ${media.name}`}
                        title="Remove"
                      >
                        ×
                      </button>

                      {!isSingle && (
                        <span style={tileBadgeStyle}>{isVideo ? 'Video' : media.name}</span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Actions apply to the selected tile (the only one, when single) */}
            <div
              className="uacp-media-actions"
              style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginTop: '10px' }}
            >
              <button
                onClick={handleOpenQuality}
                disabled={!hasMedia}
                style={hasMedia ? enabledCheckQualityStyle : disabledCheckQualityStyle}
                aria-label="Check media quality"
              >
                Check the media quality
              </button>

              <button
                onClick={handleOpenMonetisation}
                disabled={!hasMedia}
                style={hasMedia ? enabledMonetisationStyle : disabledMonetisationStyle}
                aria-label="Check monetisation"
              >
                Check Monetisation
              </button>
            </div>
          </div>
        )}
      </div>

      {qualityModal && (
        <QualityModal data={qualityModal} onClose={() => setQualityModal(null)} />
      )}

      {monetisationModal && (
        <MonetisationModal data={monetisationModal} onClose={() => setMonetisationModal(null)} />
      )}
    </div>
  );
}
